import { destroy, mutate, query, update } from "../../defaults/fetch"
import { useEffect, useState } from "react";



export const useFetchAllFinancialYears = (flag) => {
  const [years, setYears] = useState([]);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    const getAllFinancialYears = async () => {
      setLoading(true);
      const url = `financial-year/get-all-paginated`;
      const qs = {
        page: 0,
        size: 50
      }
      const { data } = await query(url, qs);
      setLoading(false);
      setYears(data.content);
    }
    getAllFinancialYears();
  }, [flag])

  return { loading, years };
}


export const useFetchAllYears = (flag) => {
  const [years, setYears] = useState([]);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    const getAllFinancialYears = async () => {
      setLoading(true);
      const url = `financial-year/get-all`;
      const qs = {}
      const { data } = await query(url, qs);
      setLoading(false);
      setYears(data);
    }
    getAllFinancialYears();
  }, [flag])

  return { loading, years };
}


export const useCreateFinanacialYear = () => {
  const createFinancialYear = async (body) => {
    const url = `financial-year/create`;
    const { message } = await mutate(url, true, body);
    return message;
  }
  return createFinancialYear;
}



export const useUpdateFinancialYear = () => {
  const updateFinancialYear = async (id, body) => {
    const url = `financial-year/update/${id}`;
    const { message } = await update(url, body);
    return message;
  }

  return updateFinancialYear;
}

export const useDeleteFinancialYear = () => {
  const deleteFinancialYear = async (id) => {
    const url = `financial-year/delete/${id}`;
    const { message } = await destroy(url);
    return message;
  }

  return deleteFinancialYear;
}
